import { FetchSearchProfilesResponse, Psychologist } from "utils/interfaces"
import { PAGE_SIZE } from "modules/PsyCatalog/browser-side"
import { FormState } from "modules/PsyCatalog/common/searchQuery/schema"
import { isBookingAvailable } from "utils/bookingAvailable"
import { UserAccount } from "utils/UserAccount"
import { httpClient } from "utils/infrastructure/httpClient"

export function searchRequest(searchQuery: FormState) {
    const payload = UserAccount.isSignedIn ? UserAccount.withUserData(searchQuery) : searchQuery
    return httpClient.post<FetchSearchProfilesResponse>(
        "search",
        Object.assign({}, payload, {
            offset_from_utc_minutes: new Date().getTimezoneOffset(),
            profiles_per_page: PAGE_SIZE,
        })
    )
}

export function searchPromotedRequest(competences: number[]) {
    const searchQuery = {
        profiles_per_page: 8,
        city: "any",
        competences: competences,
        promote: true,
    }
    return httpClient
        .post<FetchSearchProfilesResponse>(
            `search`,
            UserAccount.isSignedIn ? UserAccount.withUserData(searchQuery) : searchQuery
        )
        .then((data) => {
            data.profiles = data.profiles.filter((item) => isBookingAvailable(item))
            return data
        })
}

export function getPageOfSearchResults(hash_ids: string[]) {
    return httpClient.post<{ profiles: Psychologist[] }>("psychologists_by_hash_ids", {
        hash_ids,
        mode: "search",
        public_services_only: false,
        include_legal_info: false,
    })
}
